import type { EditableFields } from '@terra/ui-design-system';

export type FindingEditableField = keyof EditableFields;

export const FINDING_EDITABLE_FIELD_KEYS = [
  'title',
  'shortDescription',
  'description',
  'poc',
  'pocBlocks',
  'businessImpact',
  'mitigationPlan',
  'status',
  'severity',
  'category',
  'assignedTo',
  'signalId',
  'traceThreadId',
  'assets',
  'isPublished',
  'findingUpdateComment',
  'cvss',
  'cvss40',
  'cvss31',
  'severityReason',
  'owaspRisk',
] as const satisfies readonly FindingEditableField[];

export function isFindingEditableField(
  key: string,
): key is FindingEditableField {
  return (FINDING_EDITABLE_FIELD_KEYS as readonly string[]).includes(key);
}

export function normalizeFindingPatch(
  patch: Record<string, unknown>,
): Partial<EditableFields> {
  const normalized: Partial<EditableFields> = {};

  for (const [key, value] of Object.entries(patch)) {
    if (value === undefined || !isFindingEditableField(key)) {
      continue;
    }

    Object.assign(normalized, { [key]: value });
  }

  return normalized;
}
